import { ScrollFade } from '@cian/adfox-templates';

import { type FC, useRef } from 'react';

import styles from './CarouselSlide.css';

export type CarouselSlidePros = {
  imageSrc: string;
  title: string;
  description: string;
};

export const CarouselSlide: FC<CarouselSlidePros> = props => {
  const { imageSrc, title, description } = props;
  const contentRef = useRef<HTMLDivElement>(null);

  /**
   * Скролл наверх при выходе мыши с карточки
   */
  const handleMouseLeave = (): void => {
    if (contentRef.current) {
      contentRef.current.scrollTo({ behavior: 'smooth', top: 0 });
    }
  };

  return (
    <div className={styles['container']} data-testid="seria-plus-carousel-slide" onMouseLeave={handleMouseLeave}>
      <div className={styles['image-container']}>
        <img
          alt={title}
          className={styles['image']}
          data-testid="seria-plus-carousel-slide-image"
          decoding="async"
          height="100%"
          loading="lazy"
          src={imageSrc}
          width="100%"
        />
      </div>
      <div className={styles['content']} data-testid="seria-plus-carousel-slide-content" ref={contentRef}>
        <span className={styles['title']} data-testid="seria-plus-carousel-slide-title">
          {title}
        </span>
        <span className={styles['description']} data-testid="seria-plus-carousel-slide-description">
          {description}
        </span>
        <ScrollFade size={50} />
      </div>
    </div>
  );
};
